/*
  Autogenerate's sample case. OBVIOUSLY SYNTHETIC — a `TEST-CASE-` number nobody could mistake for
  one the bureau issued.
*/

function uid(): string {
  return Math.random().toString(36).slice(2, 8).toUpperCase();
}

export function sampleCase() {
  const suffix = uid();

  return {
    caseNumber: `TEST-CASE-${suffix}`,
    title: `Sample investigation ${suffix}`,
  };
}

/** A synthetic PDF that says what it is, so nobody mistakes it for a real case document. */
export function samplePdf(name: string): File {
  const body = `%PDF-1.4\n% Synthetic document created by Autogenerate - not a case document.\n%%EOF\n`;
  return new File([body], name, { type: 'application/pdf' });
}

export function sampleReport() {
  const suffix = uid();

  return {
    title: `Sample operation debrief ${suffix}`,
    summary: `Synthetic summary created by Autogenerate (${suffix}). Entry at 0400; two items recovered; no injuries.`,
  };
}
